import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import {
	QUICKSTART_UI_STATUS_NOT_LOADED,
	QUICKSTART_UI_STATUS_OPEN,
	QUICKSTART_UI_STATUS_MINIMIZED,
	QUICKSTART_UI_STATUS_DISMISSED,
	QUICKSTART_PANEL_VISIBILITY_STATE_KEY,
	type QuickstartUiStatus,
	DEFAULT_QUICKSTART_UI_STATUS,
} from '../constants.tsx';

const stringToQuickstartUiStatus = (statusString: string): QuickstartUiStatus => {
	switch (statusString) {
		case 'NOT_LOADED':
			return QUICKSTART_UI_STATUS_NOT_LOADED;
		case 'OPEN':
			return QUICKSTART_UI_STATUS_OPEN;
		case 'MINIMIZED':
			return QUICKSTART_UI_STATUS_MINIMIZED;
		case 'DISMISSED':
			return QUICKSTART_UI_STATUS_DISMISSED;
		default:
			return DEFAULT_QUICKSTART_UI_STATUS;
	}
};

export const performLoadQuickstartBannerVisibility = async (
	accountId: AccountId,
): Promise<QuickstartUiStatus> => {
	const visibilityString = await getUserProperty<string>(
		accountId,
		QUICKSTART_PANEL_VISIBILITY_STATE_KEY,
	);

	const visibility = stringToQuickstartUiStatus(visibilityString);

	return visibility;
};
